module.exports = __webpack_public_path__ + "5b8b7075f52f9e4ea006c9aae2668677.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./app/images/albumy/priestory/exterier_F21.jpg
 ** module id = 18
 ** module chunks = 0
 **/